
import { Image } from "element-ui"
import inputNumber from "./input-number.vue"
import emptyImg from "@/assets/images/empty_img.png"
import { handleAddToCartV2 } from "@/utils/cartResponse"
import { showGlobalMessage, openNoAddressPop, formatWareImgUrl, noAddressCheck, getDeliveryMethod } from "@/utils/utils"
import { trackAddToCart, trackSelectItem, handleChangeCartNumber } from "@/utils/track"

function getWareNumByCart(storeGroup) {
  let num = 0
  storeGroup.forEach(v => {
    num += Number(v.checkedCountWithoutGift)
  })
  return num
}

function getStockBySku(storeGroup, sku) {
  const cartList = []
  storeGroup.forEach(v => {
    v.wareGroup.forEach(_v => {
      if (_v.wares) {
        _v.wares.forEach(__v => {
          cartList.push({
            sku: __v.sku,
            stock: __v.stock
          })
        })
      }
    })
  })
  const item = cartList.find(v => v.sku === sku)
  const stock = item ? item.stock : 0
  return stock > 99 ? 99 : stock
}

export default {
  name: "WareViewWare",
  components: {
    [Image.name]: Image,
    inputNumber
  },
  inject: {
    getStoreId: {
      default: null
    },
    source: {
      default: null
    },
    hideProTag: {
      default: false
    }
  },
  props: {
    defaultCount: {
      type: [String, Number],
      default: 0
    },
    info: {
      type: Object,
      default: () => ({
        wareImg: "",
        warePrice: "",
        wareName: ""
      })
    },
    btnIsDisabled: {
      type: Boolean,
      default: false
    },
    defaultMax: {
      type: Number,
      default: 99
    }
  },
  data() {
    return {
      max: 99,
      count: 0,
      commonReqParams: {},
      deliveryMethod: "homeDelivery"
    }
  },
  computed: {
    showSoldTag() {
      return [1, 2].includes(this.info.wareStatus)
    },
    showProTag() {
      return (
        this.info.promotionWareVO.promotionInfoList &&
        this.info.promotionWareVO.promotionInfoList.length &&
        this.info.promotionWareVO.promotionInfoList[0].displayInfo &&
        this.info.promotionWareVO.promotionInfoList[0].displayInfo.proTag
      )
    },
    hasMutiProTag() {
      return (
        this.info.promotionWareVO.promotionInfoList &&
        this.info.promotionWareVO.promotionInfoList.length &&
        this.info.promotionWareVO.promotionInfoList.length > 1
      )
    },
    proDisplayTag() {
      return (
        this.info.promotionWareVO.promotionInfoList[0].displayInfo &&
        this.info.promotionWareVO.promotionInfoList[0].displayInfo.proTag
      )
    },
    imageUrl() {
      const imgUrl = this.info.wareImg
      if (imgUrl) {
        return formatWareImgUrl(imgUrl)
      }
      return emptyImg
    },
    detailLink() {
      return `${this.MAIN_ORIGIN}${this.MAIN_PATH}/productDetails?skuId=${this.info.sku}&name=${encodeURIComponent(
        this.info.wareName
      )}`
    }
  },
  watch: {
    defaultCount: {
      handler(newVal) {
        if (newVal !== 0) {
          this.count = newVal
        }
      },
      immediate: true
    },
    defaultMax: {
      handler(newVal) {
        this.max = newVal
      },
      immediate: true
    }
  },
  created() {
    if (!process.client) {
      return
    }
    this.deliveryMethod = getDeliveryMethod()
    const { commonReqParams } = this.$commonParams
    this.storeId = this.getStoreId ? this.getStoreId() : commonReqParams.storeId
  },

  methods: {
    fen2Yuan(num) {
      if (isNaN(num)) return ""
      num = Number(num)
      return (num / 100).toFixed(2)
    },
    getNumber(nums) {
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res[0]
    },
    getSmallNumber(nums) {
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res.length === 2 ? res[1] : ""
    },
    handleNumChange(val) {
      handleChangeCartNumber(val, this.count, this.info)
      this.count = val
    },
    async handleAdd() {
      if (this.btnIsDisabled) {
        window.location.href = `${this.MAIN_ORIGIN}${this.MAIN_PATH}/similar?skuId=${this.info.sku}`
        return
      }

      if (noAddressCheck()) {
        openNoAddressPop()
        return
      }

      const loading = this.$loading({
        background: "rgba(0, 0, 0, 0)"
      })
      const [error, data, wareList] = await handleAddToCartV2({
        storeId: this.storeId,
        wares: [{ sku: this.info.sku, beforeCount: 0, count: 1, checked: 1 }],
        sort: 1
      })
      if (error) {
        if (error.code == "44999") {
          openNoAddressPop()
        } else {
          // this.$message.error(error.result)
        }
      }
      if (data) {
        this.$bus.$emit("add-cart-success", this.source)
        if (this.source === "collect") {
          this.$bus.$emit("reload-collect")
        }
        this.count = 1
      }
      if (wareList) {
        const item = wareList.find(v => v.skuId === this.info.sku)
        this.max = item && item.stock ? item.stock : 99
      }
      loading.close()
      trackAddToCart(this.info)
    },
    trackSelectItem
  }
}
